module.exports = __webpack_public_path__ + "static/img/5-01.fb05462.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/custDetail/5-01.png
// module id = QEhH
// module chunks = 1